<template>
  <div class="container">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('courses.guidance.back') }}</span>
    </div>
    <a-form :form="form" class="g-form">
      <div class="header">
        <span class="title">{{ !id ? $t('courses.guidance.create') : $t('courses.guidance.edit') }}</span>
      </div>
      <div class="list">
        <a-form-item :label="$t('courses.guidance.guidanceType')" :colon="false">
          <a-select
            v-decorator="['guidanceType', { rules: [{ required: true, message: $t('courses.guidance.selectGuidanceType') }] }]"
            :placeholder="$t('courses.guidance.selectGuidanceType')"
            allowClear
            @change="changeGuidance"
          >
            <a-select-option v-for="item in guidanceOptions" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('courses.guidance.selectClass')" :colon="false">
          <a-select
            v-decorator="['classId', { rules: [{ required: true, message: $t('courses.guidance.selectClass') }] }]"
            :placeholder="$t('courses.guidance.selectClass')"
            allowClear
          >
            <a-select-option v-for="item in classOptions" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div class="list" v-if="guidanceType !== '1'">
        <a-form-item :label="$t('courses.guidance.time')" :colon="false">
          <a-range-picker
            hideDisabledOptions
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="[$t('courses.guidance.startTime'), $t('courses.guidance.endTime')]"
            v-decorator="['timeList', { rules: [{ required: true, message: $t('courses.guidance.selectStartEndTime') }] }]"
            :disabledDate="disabledStartDate"
            :disabledTime="disabledStartTime"
            :showTime="{ format: 'HH:mm' }"
            style="width: 100%;"
          >
            <img src="@/assets/icons/icon_rq.png" slot="suffixIcon" />
          </a-range-picker>
        </a-form-item>
        <a-form-item style="position: relative;" :label="$t('courses.guidance.chapterSettings')" :colon="false" v-if="guidanceType === '3'">
          <a-select
            class="form-chapter-select"
            mode="multiple"
            style="width: 100%"
            :placeholder="$t('courses.guidance.selectChapter')"
            v-decorator="['privateChaptersIds', { rules: [{ required: true, message: $t('courses.guidance.selectChapter') }] }]"
            dropdownClassName="chapter-dropdown"
            @change="changeChapter"
          >
            <a slot="menuItemSelectedIcon" />
            <a-select-option v-for="i in chapterListClone" :key="i.id" :value="i.id">
              <a-checkbox style="margin-right: 8px;" v-model="i.checked" />
              <span> {{ i.name }} </span>
            </a-select-option>
          </a-select>
          <a-icon class="down-icon" type="down" />
        </a-form-item>
        <a-form-item :label="$t('courses.guidance.proceedAfterError')" :colon="false" v-if="guidanceType === '4'">
          <a-select
            v-decorator="['allowProceedAfterError', { rules: [{ required: true, message: $t('courses.guidance.selectGuidanceType') }] }]"
            :placeholder="$t('courses.guidance.selectGuidanceType')"
            allowClear
          >
            <a-select-option :value="true">
              {{ $t('courses.guidance.yes') }}
            </a-select-option>
            <a-select-option :value="false">
              {{ $t('courses.guidance.no') }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div v-if="guidanceType === '4'">
        <a-form-item :label="$t('courses.guidance.challengeSettings')" :colon="false">
          <a-input
            v-decorator="['settings', { rules: [{ required: true, message: $t('courses.guidance.setChallengeSettings') }] }]"
            style="display: none;"
          />
          <div class="l-table">
            <div class="l-table-header">
              <div
                class="l-table-head-cell"
                v-for="(item, index) in columns"
                :key="index"
                :style="{ width: item.width + 'px', flex: index == 2 ? 1 : '' }"
              >
                {{ item.hidden ? '' : $t('courses.guidance.' + item.title) }}
              </div>
            </div>
            <div class="l-table-body">
              <div class="l-table-row" v-for="(record, index) in topicList" :key="index">
                <div class="l-table-cell-left" :style="{ width: columns[0].width + 'px' }">
                  <div class="name">
                    {{ record.name }}
                  </div>
                  <div class="remove" @click="removeChapter(index)">
                    <img src="@/assets/icons/icon_del@2x.png" alt="" />
                  </div>
                </div>
                <div class="l-table-cell">
                  <div class="l-table-cell-row" v-for="(child, cindex) in record.children" :key="cindex">
                    <div class="l-table-cell-cell" :style="{ width: columns[1].width + 'px' }">
                      <a-select
                        style="width: 90%"
                        :placeholder="$t('courses.guidance.selectGuidanceType')"
                        v-model="child.topicType"
                        @change="changeType(child)"
                      >
                        <a-select-option :value="item.value" v-for="(item, index) in testPaperTypeList" :key="index">
                          {{ item.label }}
                        </a-select-option>
                      </a-select>
                    </div>
                    <div class="l-table-cell-cell" style="flex: 1">
                      <a-select style="width: 90%" :placeholder="$t('courses.guidance.selectQuestionContent')" v-model="child.id">
                        <a-select-option :value="item.id" v-for="(item, index) in child.testQuestionsList" :key="index">
                          {{
                            item.subjectContent.length > 40
                              ? item.subjectContent.slice(0, 40) + '...'
                              : item.subjectContent
                          }}
                        </a-select-option>
                      </a-select>
                    </div>
                    <div class="l-table-cell-cell" :style="{ width: columns[3].width + 'px' }">
                      <a-button type="link" @click="removeTopic(record, cindex)">{{ $t('courses.guidance.delete') }}</a-button>
                    </div>
                  </div>
                  <div class="l-table-cell-row" v-if="record.children.length < 3">
                    <div class="l-table-cell-cell" style="width: 100%;">
                      <a-button type="link" @click="addTopic(record)"><a-icon type="plus" /> {{ $t('courses.guidance.addQuestion') }}</a-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a-button style="margin-top: 15px; font-size: 13px;" @click="addChapter">
            <a-icon type="plus" /> {{ $t('courses.guidance.addChapter') }}</a-button
          >
        </a-form-item>
      </div>
    </a-form>
    <div class="list-button">
        <a-button type="primary" @click="save">{{ $t('courses.guidance.confirm') }}</a-button>
      </div>
    <a-modal v-model="visible" :title="$t('courses.guidance.selectChapter')" @ok="saveChapter(false)">
        <a-form>
          <a-form-item :label="$t('courses.guidance.selectedChapters')" :colon="false">
          <div class="chapter-select">
            <a-select
              mode="multiple"
              style="width: 100%"
              :placeholder="$t('courses.guidance.selectChapter')"
              v-model="selectedChapter"
              dropdownClassName="chapter-dropdown"
              :getPopupContainer="getPopupContainer"
            >
              <!-- <a slot="menuItemSelectedIcon" /> -->
              <a-select-option v-for="i in chapterList" :key="i.id" :value="i.id">
                <a-checkbox style="margin-right: 8px;" v-model="i.checked" />
                <span> {{ i.name }} </span>
              </a-select-option>
            </a-select>
            <img class="search" src="@/assets/icons/icon_search@2x.png" alt="" />
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import moment from 'moment'
import Pagination from '@/components/pagination/index.vue'
import NoData from '@/components/noData/index'
import { classMap, getTopicByType, saveGuidance, guidanceDetail, chapterList } from '@/api/lesson'
import TipModal from '@/components/tipModal/index.vue'

export default {
  components: {
    NoData,
    Pagination,
    TipModal
  },
  data() {
    return {
      id: undefined,
      list: [],
      locale: {
        emptyText: <NoData />
      },
      classOptions: [],
      form: this.$form.createForm(this),
      guidanceOptions: [
        {
          id: '1',
          name: this.$t('courses.guidance.public')
        },
        {
          id: '2',
          name: this.$t('courses.guidance.scheduledPublic')
        },
        {
          id: '3',
          name: this.$t('courses.guidance.private')
        },
        {
          id: '4',
          name: this.$t('courses.guidance.challenge')
        }
      ],
      guidanceType: '1',
      columns: [
        {
          title: 'chapter',
          dataIndex: '',
          width: 300
        },
        {
          title: 'challengeQuestionType',
          dataIndex: '',
          width: 130,
          hidden: true
        },
        {
          title: 'question',
          dataIndex: ''
        },
        {
          title: 'operation',
          dataIndex: '',
          width: 100
        }
      ],
      topicList: [],
      testPaperTypeList: [
        {
          label: this.$t('courses.guidance.singleChoice'),
          value: 1
        },
        {
          label: this.$t('courses.guidance.multipleChoice'),
          value: 2
        },
        {
          label: this.$t('courses.guidance.trueFalse'),
          value: 4
        }
      ],
      visible: false,
      selectedChapter: [],
      chapterList: [],
      chapterListClone: []
    }
  },
  watch: {
    selectedChapter(val) {
      if (Array.isArray(val)) {
        this.chapterList.forEach((item, index) => {
          item.checked = val.includes(item.id)
        })
      }
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: this.guidanceId ? 'lessonList' : 'myCourses'
      })
    },
    save(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.guidanceType === '4') {
            // 检查题目是否为空
            const hasEmptyTopic = this.topicList.some(chapter => chapter.children.length === 0)
            if (hasEmptyTopic) {
              return this.$message.warning(this.$t('courses.guidance.pleaseAddQuestions'))
            }
          }
          const data = Object.assign({
            ...values,
            lessonId: this.id,
            id: this.guidanceId
          })
          if (values.timeList && values.timeList.length === 2) {
            data.startTime = values.timeList[0]
            data.endTime = values.timeList[1]
          }
          if (this.guidanceType === '4') {
            data.challengeConfigs = this.topicList.map(item => {
              return {
                chapterId: item.id,
                questions: item.children.map(child => child.id)
              }
            })
          }
          if (this.guidanceType === '3' && values.privateChaptersIds.length === this.chapterListClone.length) {
            this.$message.warning(this.$t('courses.guidance.keepAtLeastOneChapter'))
            return
          }
          console.log('Received values of form: ', data)
          saveGuidance(data).then(res => {
            if (res.code == 200) {
              // const tip = this.id ? '编辑' : '创建'
              this.$message.success(this.$t('courses.guidance.publishSuccess'))
              this.back()
            }
          })
        }
      })
    },
    getClassList() {
      classMap().then(res => {
        if (res.code != 200) return
        this.classOptions = res.data.list
      })
    },
    changeGuidance(value) {
      this.guidanceType = value
    },
    disabledStartDate(current) {
      // 检查 current 是否为 undefined
      if (!current) {
        return false
      }
      // 禁用早于当前日期的日期
      if (current < moment().startOf('day')) {
        return true
      }
      const [startTime] = this.form.getFieldValue('timeList') || []
      if (startTime) {
        // 只允许选择同一天
        return !current.isSame(startTime, 'day')
      }
      return false
    },
    disabledStartTime(_, type) {
      if (type === 'start') {
        return {
          disabledHours: () => [],
          disabledMinutes: () => [],
          disabledSeconds: () => []
        }
      }
      const [startTime] = this.form.getFieldValue('timeList') || []
      if (startTime) {
        const endMaxTime = moment(startTime).add(120, 'minutes')
        return {
          disabledHours: () => {
            const hours = []
            for (let i = 0; i < 24; i++) {
              const testTime = moment(startTime)
                .clone()
                .hour(i)
              if (testTime.isBefore(startTime) || testTime.isAfter(endMaxTime)) {
                hours.push(i)
              }
            }
            return hours
          },
          disabledMinutes: selectedHour => {
            const [startTime] = this.form.getFieldValue('timeList') || []
            if (!startTime) {
              return [] // 如果 timeList 无效，返回空数组
            }
            const endMaxTime = moment(startTime).add(120, 'minutes')
            const minutes = []
            // 检查 selectedHour 是否为有效的数字
            if (typeof selectedHour === 'number' && selectedHour >= 0 && selectedHour < 24) {
              for (let i = 0; i < 60; i++) {
                const testTime = moment(startTime)
                  .clone()
                  .hour(selectedHour)
                  .minute(i)
                if (testTime.isBefore(startTime) || testTime.isAfter(endMaxTime)) {
                  minutes.push(i)
                }
              }
            }
            return minutes
          },
          disabledSeconds: () => []
        }
      }
      return {
        disabledHours: () => [],
        disabledMinutes: () => [],
        disabledSeconds: () => []
      }
    },
    checkStartDate(value) {
      // 可以在这里添加额外的验证逻辑
    },
    calendarChange(value) {
      // this.form.getFieldValue('timeList') = value
    },
    remove(record) {},
    addChapter() {
      console.log('selectedChapter ----->', this.selectedChapter)
      this.visible = true
    },
    addTopic(record) {
      this.columns[1].hidden = false
      record.children.push({
        topicId: '',
        topicType: '',
        topicName: '',
        testQuestionsList: []
      })
    },
    removeTopic(record, index) {
      record.children.splice(index, 1)
      // 判断所有章节下的题目列表是否为空
      console.log('this.topicList ----->', this.topicList)
      const allEmpty = this.topicList.every(chapter => chapter.children.length === 0)
      console.log('allEmpty ----->', allEmpty)
      if (allEmpty) {
        this.columns[1].hidden = true
      }
    },
    changeType(child, questionId) {
      const value = child.topicType
      child.topicId = ''
      getTopicByType({ type: value }).then(res => {
        child.testQuestionsList = res.data[value - 1]
        if (questionId) child.id = questionId
      })
      this.form.setFieldsValue({
        settings: 1
      })
    },
    removeChapter(index) {
      const [deletedChapter] = this.topicList.splice(index, 1)
      this.selectedChapter.forEach((item, inx) => {
        if (item === deletedChapter.id) {
          this.selectedChapter.splice(inx, 1)
        }
      })
    },
    getPopupContainer(triggerNode) {
      return triggerNode.parentNode
    },
    saveChapter(isCreated = false) {
      // 备份当前 topicList
      const backupTopicList = JSON.parse(JSON.stringify(this.topicList))
      this.topicList = []
      this.chapterList.map(item => {
        if (item.checked) {
          // 从备份中查找是否有对应的章节数据
          const backupChapter = isCreated ? item : backupTopicList.find(chapter => chapter.id === item.id)
          this.topicList.push({
            id: item.id,
            name: item.name,
            children: backupChapter ? backupChapter.children || [] : []
          })
        }
      })
      console.log('isCreatedq  ----->', isCreated)
      if (isCreated) {
        this.columns[1].hidden = false
      }
      this.visible = false
    },
    getGuidanceDetail() {
      guidanceDetail({ id: this.guidanceId }).then(res => {
        if (res.code === 200) {
          this.guidanceType = res.data.guidanceType
          this.$nextTick(() => {
            this.form.setFieldsValue({
              guidanceType: res.data.guidanceType,
              classId: res.data.classId,
              privateChaptersIds: res.data.challengeConfigs.map(item => item.chapterId),
              allowProceedAfterError: res.data.allowProceedAfterError,
              timeList: [res.data.startTime, res.data.endTime]
            })
            // 选中章节
            if (res.data.challengeConfigs) this.setChapterTopic(res.data.challengeConfigs)
          })
        }
      })
    },
    setChapterTopic(resData) {
      console.log('resData ----->', resData)
      if (Array.isArray(resData)) {
        resData.forEach(chapter => {
          console.log('this.chapterList ----->', this.chapterList.length)
          this.chapterList.forEach(item => {
            if (chapter.chapterId === item.id) {
              item.checked = true
              item.children = chapter.questionList.map(child => {
                const topic = {
                  topicType: Number(child.questionType),
                  testQuestionsList: []
                }
                this.changeType(topic, child.questionId)
                return topic
              })
              if (this.selectedChapter.indexOf(item.id) === -1) {
                this.selectedChapter.push(item.id)
              }
            }
          })
        })
        this.saveChapter(true)
      }
    },
    getChapterList() {
      return new Promise((resolve, reject) => {
        chapterList({ lessonId: this.id }).then(res => {
          if (res.code === 200) {
            this.chapterList = res.data.list.map(item => {
              return {
                ...item,
                checked: false
              }
            })
            this.chapterListClone = JSON.parse(JSON.stringify(this.chapterList))
            if (this.chapterList.length > 0) {
              const checkedChapter = this.chapterList[0]
              checkedChapter.checked = true
              if (this.selectedChapter.indexOf(checkedChapter.id) === -1) {
                this.selectedChapter.push(checkedChapter.id)
              }
              this.saveChapter()
            }
            resolve()
          }
        })
      })
    },
    changeChapter(val) {
      if (Array.isArray(val)) {
        this.chapterListClone.forEach((item, index) => {
          item.checked = val.includes(item.id)
        })
      }
    }
  },
  async mounted() {
    this.id = this.$route.query.id
    this.guidanceId = this.$route.query.guidanceId
    await this.getClassList()
    await this.getChapterList()
    if (this.guidanceId) {
      await this.getGuidanceDetail()
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 18px 21px;
  .down-icon {
    position: absolute;
    right: 12px;
    top: 5px;
    color: #b4b4b4;
    font-size: 12px;
  }
}
.header {
  margin-bottom: 22px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ededed;
  .title {
    font-size: 16px;
    font-weight: 800;
    color: #000000;
  }
}
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
.button {
  cursor: pointer;
}
.g-form {
  position: relative;
  height: calc(100% - 100px);
  overflow-x: auto;
  .list {
    display: flex;
    margin-bottom: 12px;
    .ant-form-item-label {
      font-size: 14px;
      color: #000;
      line-height: 20px;
    }
    .ant-form-item {
      width: calc((100% - 140px) / 2);
      margin-bottom: 0;
      margin-right: 70px;
    }
    /deep/.select-button.ant-btn.disabled {
      color: #a2a2a2 !important;
      background: none;
    }
    /deep/.ant-input,
    /deep/.select-button.ant-btn,
    /deep/.ant-input-affix-wrapper {
      width: 100%;
      height: 35px;
      color: #000000 !important;
      margin-right: 11px;
    }
    /deep/.ant-select-selection__rendered {
      .ant-select-selection-selected-value {
        color: #000;
      }
    }
    .ant-calendar-picker div {
      position: relative;
      .ant-calendar-picker-input .ant-input {
        width: 100%;
        height: 35px;
        margin-right: 0;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d8dce0;
      }
    }
    .select-button,
    .ant-calendar-picker {
      width: 100%;
      height: 35px;
      color: #000000;
      line-height: 35px;
    }
    .select-button {
      padding: 0 20px;
      text-align: left;
      color: #a2a2a2;
      position: relative;
      img {
        top: 14px;
        width: 11px;
        right: 20px;
        position: absolute;
      }
    }
  }
  .form-chapter-select {
    /deep/ .ant-select-selection__choice__content {
      label {
        display: none;
      }
    }
    /deep/ .ant-select-selection {
      padding: 3px 0px 5px;
    }
    /deep/ .ant-select-selection__choice {
      background: #f2f2f6;
      border-color: #f2f2f6;
    }
  }
}
.list-button {
  display: flex;
  justify-content: center;
}
/deep/.ant-modal {
  .ant-modal-title {
    font-size: 16px;
    font-weight: 550;
  }
  .total {
    color: #687f9c;
    margin: 12px 0;
  }
  .ant-input-group-wrapper {
    width: 330px;
    height: 35px;
    margin-bottom: 22px;
    .ant-input-prefix {
      // right: auto;
      left: 16px;
      img {
        width: 16px;
      }
    }
    .ant-input-suffix {
      right: 0;
      .anticon.anticon-close-circle.ant-input-clear-icon {
        display: none;
      }
      .clear {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }
    .ant-input-search {
      height: 35px;
      .ant-input {
        height: 35px;
        color: #000;
        padding-left: 46px;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border-color: #d8dce0;
        box-shadow: none;
      }
    }
    .ant-input-group-addon .search-btn {
      border-left: 0;
      height: 35px;
      border-color: #d8dce0;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      span {
        display: flex;
        font-size: 14px;
        color: #333333;
        position: relative;

        &::before {
          left: -8px;
          content: '';
          width: 1px;
          height: 15px;
          background: #e9e9e9;
          position: absolute;
        }
      }
    }
    // border: 1px solid #D8DCE0;
  }
  .ant-modal-body {
    position: relative;
    padding-top: 15px;
    .ant-form-item {
      margin-bottom: 0px;
    }
    .ant-table-wrapper {
      margin-bottom: 60px;
      .prepare-name {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        white-space: nowrap;
        display: inline-block;
      }
      .button {
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        color: #5b7499;
        line-height: 20px;
        margin-right: 10px;
      }
    }
    .list-pagination {
      width: calc(100% - 48px);
      bottom: 80px;
      position: absolute;
      .pagination {
        padding: 25px 0;
      }
    }
  }
}

// 表格样式
.l-table {
  width: 100%;
  .l-table-header {
    display: flex;
    background-color: #edf2f6;
    color: #6b738c;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    .l-table-head-cell {
      width: 100px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
    }
  }
  .l-table-body {
    .l-table-row {
      display: flex;
      // border-bottom: 1px solid #e9e9e9;
      .l-table-cell-left {
        width: 200px;
        line-height: 1.8;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #000;
        text-align: center;
        border: solid 1px #e9e9e9;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: none;
        border-top: none;
        flex-direction: column;

        padding: 0 10px;
        position: relative;
        .name {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          font-weight: bold;
          font-size: 16px;
        }
        .remove {
          height: 13px;
          width: 13px;
          position: absolute;
          right: 5px;
          top: 0px;
          cursor: pointer;
          display: none;
          color: #a2a2a2;
          img {
            width: 13px;
            height: 13px;
          }
        }
        &:hover {
          background-color: #f6f6f6;
          .remove {
            display: block;
          }
        }
      }
      &:last-child {
        border-bottom: none;
      }
      .l-table-cell {
        flex: 1;
        line-height: 45px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #000;
        .l-table-cell-row {
          display: flex;
          text-align: center;
          width: 100%;
          .l-table-cell-cell {
            height: 45px;
            line-height: 45px;
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: #000;
            border: 1px solid #e9e9e9;
            border-top: none;
            // 添加偶数个单元格的样式
            &:nth-child(even) {
              border-left: none;
              border-right: none;
            }
          }
        }
      }
    }
    .ant-btn-link {
      font-size: 12px;
      color: #8189a3;
    }
  }
  /deep/ .ant-select-selection-selected-value,
  .ant-select-selection__placeholder {
    width: 100%;
  }
  /deep/ .ant-select-selection__rendered {
    text-align: center;
  }
}

.chapter-modal {
  color: red !important;
  .ant-select-selection__choice {
    .ant-checkbox-wrapper {
      display: none;
    }
  }
}
</style>

<style lang="less">
.chapter-dropdown {
  .ant-select-dropdown-menu-item-selected::after {
    display: none;
  }
  .ant-select-dropdown-menu-item {
    border: none;
    // &:hover {
    //   background-color: rgba(0, 0, 0, 0.08);
    // }
  }
  .ant-popover {
    .ant-btn.ant-btn-primary,
    .ant-btn.ant-btn-primary:hover {
      width: auto;
      height: auto;
    }
  }
}
.chapter-select {
  position: relative;
  .search {
    position: absolute;
    right: 10px;
    top: 13px;
    width: 16px;
    height: 16px;
  }
  .ant-select-selection__choice__content {
    label {
      display: none;
    }
  }
  .ant-select-selection {
    padding: 3px 0px 5px;
  }
  .ant-select-selection__choice {
    background: #f2f2f6;
    border-color: #f2f2f6;
  }
}
</style>
